export class Product {
  private productKey: string;
  private ean: string;
  private productName: string;
  private presentation: string;
  private laboratory: string;
  private productSubType: string;

  setProductKey(value: string): void {
    this.productKey = value;
  }

  getProductKey(): string {
    return this.productKey;
  }

  setEan(value: string): void {
    this.ean = value;
  }

  getEan(): string {
    return this.ean;
  }

  setProductName(value: string): void {
    this.productName = value;
  }

  getProductName(): string {
    return this.productName;
  }

  setPresentation(value: string): void {
    this.presentation = value;
  }

  getPresentation(): string {
    return this.presentation;
  }

  setLaboratory(value: string): void {
    this.laboratory = value;
  }

  getLaboratory(): string {
    return this.laboratory;
  }

  setProductSubType(value: string): void {
    this.productSubType = value;
  }

  getProductSubType(): string {
    return this.productSubType;
  }
}
